exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_data[data-v-579a9458] {\n  border: 1px solid #78a5e7;\n  min-height: 500px;\n  padding: 20px 34px;\n}\n.footer_task[data-v-579a9458] {\n  margin-top: 20px;\n}\n.container_nav_page[data-v-579a9458] .el-pagination {\n  display: flex;\n  justify-content: end;\n}\n.menu_task_form[data-v-579a9458] {\n  background-color: transparent !important;\n  display: flex;\n  justify-content: end;\n  align-content: center;\n}\n", ""]);

// exports
